export function isFullscreen() {
  return (
    Boolean(document.fullscreenElement) ||
    Boolean(document.webkitFullscreenElement) ||
    Boolean(document.webkitCurrentFullScreenElement) ||
    Boolean(document.mozFullScreenElement) ||
    Boolean(document.msFullscreenElement)
  );
}
